import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["sessions", "onRefresh"];
import { groupUpcomingSessionsByDate } from "../../utils/groupUpcomingSessionsByDate";
import { isToday } from "../../utils/isToday";
import { DateWithSessionsList } from "../ui/DateWithSessionsList";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var UpcomingSessions = function UpcomingSessions(_ref) {
  var sessions = _ref.sessions,
    onRefresh = _ref.onRefresh,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _groupUpcomingSession = groupUpcomingSessionsByDate(sessions),
    upcomingSessions = _groupUpcomingSession.upcomingSessions;
  var todaySessions = upcomingSessions[0] && isToday(upcomingSessions[0].date) ? upcomingSessions.shift() : null;
  return /*#__PURE__*/_jsxs("ol", {
    className: "tw-space-y-4",
    children: [todaySessions && /*#__PURE__*/_jsx("li", {
      className: "tw-space-y-1.6 tw-rounded-[20px] tw-p-2.4 tw-bg-primary-light-100 dark:tw-bg-neutral-dark-700",
      children: /*#__PURE__*/_jsx(DateWithSessionsList, _objectSpread(_objectSpread({
        onRefresh: onRefresh
      }, todaySessions), otherProps))
    }), upcomingSessions.length > 0 && /*#__PURE__*/_jsx("li", {
      className: "tw-space-y-4 tw-rounded-[20px] tw-p-2.4 tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-02",
      children: upcomingSessions.map(function (props) {
        return /*#__PURE__*/_jsx("div", {
          className: "tw-space-y-4",
          children: /*#__PURE__*/_jsx(DateWithSessionsList, _objectSpread(_objectSpread({
            onRefresh: onRefresh
          }, otherProps), props))
        }, props.date.toISOString());
      })
    })]
  });
};